import { useQuery } from '@apollo/client';
import type { Option } from '@openx/types/options.ts';
import {
  GetAccountListOptionsDocument,
  type GetAccountListOptionsQuery,
  type GetAccountListOptionsQueryVariables,
} from '../../../graphql/query/audiences/GetAccountListOptions.generated.tsx';

const mapArrayToIdName = <T extends { id?: string | null; name?: string | null }>(arr: T[]): Option[] => {
  return arr.reduce<Option[]>((acc, item) => {
    if (item.id && item.name) {
      acc.push({ id: item.id, name: item.name === 'OpenAudience' ? 'OpenXSelect' : item.name });
    }

    return acc;
  }, []);
};

export const useDealPromptAudienceAccountOptions = (filters: GetAccountListOptionsQueryVariables, skip?: boolean) => {
  const {
    data: accountList,
    loading: accountsLoading,
    error,
  } = useQuery<GetAccountListOptionsQuery>(GetAccountListOptionsDocument, {
    variables: { ...filters },
    skip: skip,
  });

  return {
    data: mapArrayToIdName(accountList?.account_list || []),
    loading: accountsLoading,
    error,
  };
};
